import React from 'react';

const { Provider, Consumer } = React.createContext(null);

export const LoggedInProvider = Provider;
export const LoggedInConsumer = Consumer;
